<template>
    <span v-if="!isDropDownItemHidden(dropdownItemInner)">
        <!-- Button -->
        <!-- 
            TODO: We could move some of the functionality from the DropdownCompButton into the ButtonComp/ButtonBasic, 
            and just have Button here, not a special component. 
        -->
        <DropdownCompButton
            v-if="dropdownItemInner instanceof DropdownItemButton"
            :dropdownItem="dropdownItemInner"
            :action-param="actionParam"
        />

        <!-- InputText -->
        <!-- TODO: Whats the syntax for the modifiers -->
        <!-- 
            TODO: The inputs based on InputTextBase should have their labels the same width.
            For now they are just whatever length the text needs
        -->
        <InputText
            v-else-if="dropdownItemInner instanceof DropdownItemTextInput"
            v-model="dropdownItemInner.modelValue.value"
            v-bind="dropdownItemInner.props"
        />

        <!-- InputInt -->
        <InputInt
            v-else-if="dropdownItemInner instanceof DropdownItemIntInput"
            v-model="dropdownItemInner.modelValue.value"
            v-bind="dropdownItemInner.props"
        />

        <!-- InputNullableInt -->
        <InputNullableInt
            v-else-if="dropdownItemInner instanceof DropdownItemIntNullableInput"
            v-model="dropdownItemInner.modelValue.value"
            v-bind="dropdownItemInner.props"
        />

        <!-- InputFloat -->
        <InputFloat
            v-else-if="dropdownItemInner instanceof DropdownItemFloatInput"
            v-model="dropdownItemInner.modelValue.value"
            v-bind="dropdownItemInner.props"
        />

        <!-- InputNullableFloat -->
        <InputNullableFloat
            v-else-if="dropdownItemInner instanceof DropdownItemFloatNullableInput"
            v-model="dropdownItemInner.modelValue.value"
            v-bind="dropdownItemInner.props"
        />

        <!-- Checkbox -->
        <InputBool
            v-else-if="dropdownItemInner instanceof DropdownItemCheckbox"
            v-model="dropdownItemInner.modelValue.value"
            v-bind="dropdownItemInner.props"
        />

        <!-- Radio -->
        <InputRadio
            v-else-if="dropdownItemInner instanceof DropdownItemRadio"
            v-model="dropdownItemInner.modelValue.value"
            v-bind="dropdownItemInner.props"
        />

        <!-- Select -->
        <InputSelect
            v-else-if="dropdownItemInner instanceof DropdownItemSelect"
            v-model="dropdownItemInner.modelValue.value"
            v-bind="dropdownItemInner.props"
        />

        <!-- Custom component -->
        <component
            v-if="dropdownItemInner instanceof DropdownItemCustom"
            :is="dropdownItemInner.component"
            v-bind="dropdownItemInner.props"
            v-model="dropdownItemInner.modelValue.value"
        />

        <!-- Group / Submenu -->
        <DropdownComp
            v-else-if="dropdownItemInner instanceof DropdownItemMenu"
            :showArrow="true"
            :button-type="dropdownMenuTriggerButtonType ?? 'Custom'"
            :dropdownItems="dropdownItemInner.dropdownItems"
            auto-close="outside"
            :translationkey="unref(dropdownItemInner.translationkey)"
            :icon="dropdownItemInner.icon"
            :class="$attrs.class"
        />

        <DropdownSeparator v-else-if="dropdownItemInner instanceof DropdownItemSeparator" />

        <DropDownLabel
            v-else-if="dropdownItemInner instanceof DropdownItemLabel"
            v-bind="dropdownItemInner.props"
        />
    </span>
</template>
<script
    lang="ts"
    setup
    generic="TParam = any, TAction extends (...args: any[]) => any | Promise<any> = (param: TParam) => any | Promise<any>"
>
import {
    DropdownComp,
    DropdownCompButton,
    DropDownLabel,
    DropdownSeparator,
    InputBool,
    InputFloat,
    InputInt,
    InputNullableFloat,
    InputNullableInt,
    InputRadio,
    InputSelect,
    InputText,
    type ButtonTypes,
} from '@/components';
import {
    DropdownItemButton,
    DropdownItemCheckbox,
    DropdownItemCustom,
    DropdownItemFloatInput,
    DropdownItemFloatNullableInput,
    DropdownItemIntInput,
    DropdownItemIntNullableInput,
    DropdownItemLabel,
    DropdownItemMenu,
    DropdownItemRadio,
    DropdownItemSelect,
    DropdownItemSeparator,
    DropdownItemTextInput,
    type DropdownItemTypes,
} from '@/objects';
import { computed, unref } from 'vue';

/**
 * This component is used to render a single item in the DropdownComp
 */

const props = defineProps<{
    dropdownItem: DropdownItemTypes<TAction>;

    actionParam?: TParam;

    // TODO: This should probably not be here.
    // We should finish making the button a proper thing that inherits the button props
    dropdownMenuTriggerButtonType?: ButtonTypes;
}>();

const dropdownItemInner = computed(() => props.dropdownItem);

const isDropDownItemHidden = (dropdownItem: DropdownItemTypes) => {
    if (dropdownItem.hideDropDownItem === undefined) {
        return false;
    }
    return dropdownItem.hideDropDownItem.value;
};
</script>
